import React, { useEffect } from "react";
import styles from "./styles.module.scss";

export default ({ scrollTo }) => {
    useEffect(() => {
        if (scrollTo) {
            const cookiePolicy = document.getElementById(scrollTo);
            cookiePolicy && cookiePolicy.scrollIntoView();
        }
    }, [scrollTo]);

    return (
        <div className={styles.privacy}>
            <div className={`${styles.document} ${styles.korean}`}>
                <h1>개인정보 수집ㆍ이용 안내문</h1>
                <div className={styles.section}>
                    <p>
                        주식회사 한국증권대차(구 트루테크놀로지스)(이하
                        ‘회사’)는 「개인정보 보호법」 등 관련 법규에 따라
                        이용자로부터 아래와 같은 개인정보 수집ㆍ이용 동의를
                        받고자 합니다. 내용을 상세히 읽어보신 후 서비스를 계속
                        이용하거나, “계속”, “로그인”, “인증번호 받기”, “서비스
                        이용” 등의 절차를 진행하는 경우 본 안내문에 따른
                        개인정보 수집·이용에 동의한 것으로 봅니다. 보다 자세한
                        내용은 회사의 개인정보처리방침을 참조하여 주시기
                        바랍니다.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2 className={styles.subSectionTitle}>
                        <strong>[필수] 개인정보 수집∙이용 안내문</strong>
                    </h2>
                </div>
                <div className={styles.section}>
                    <h2>1. 수집하는 개인정보 항목</h2>
                    <p>
                        회사는 고객에 대한 서비스의 제공, 원활한 고객상담 등을
                        위하여 회원(서비스를 제공 받기 위하여 회사와 이용계약을
                        체결하거나 이용자 아이디를 부여 받은 고객) 및
                        비회원(회원이 아닌 고객)으로부터 다음과 같은 정보를
                        수집합니다.
                    </p>
                    <p>가. 회원</p>
                    <ul>
                        <li>
                            (1) 필수 수집 항목: 성명, 비밀번호, 이메일, 회사명,
                            회사 전화번호
                        </li>
                        <li>
                            (2) 서비스 이용과정이나 사업 처리과정에서 아래와
                            같은 정보들이 생성되어 수집될 수 있습니다: 서비스
                            이용 기록, 접속 로그, 접속 IP정보, 쿠키
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <p>나. 비회원</p>
                    <ul>
                        <li>(1) 필수 수집 항목: 성명, 이메일, 회사명</li>
                        <li>
                            (2) 서비스 이용과정이나 사업 처리과정에서 아래와
                            같은 정보들이 생성되어 수집될 수 있습니다: 서비스
                            이용 기록, 접속 로그, 접속 IP정보, 디바이스 ID, 쿠키
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>2. 개인정보의 수집 목적</h2>
                    <p>회사는 다음과 같은 목적으로 개인정보를 수집합니다.</p>
                    <p>가. 회원 </p>
                    <ul>
                        <li>(1) 회원가입 및 관리</li>
                        <p>
                            회원 가입의사 확인, 회원제 서비스 제공에 따른
                            본인확인, 본인 식별·인증, 회원자격 유지·관리, 서비스
                            부정이용 방지, 각종 고지·통지, 서비스 관련 문의 및
                            불만사항 처리, 분쟁 조정을 위한 기록 보존, 새로운
                            서비스의 소개 및 고지사항 전달, 본인 의사 확인을
                            목적으로 개인정보를 처리합니다.
                        </p>
                        <div className={styles.subSection}>
                            <li>
                                (2) 서비스 제공
                                <p>
                                    서비스 제공에 관한 계약 이행 및 서비스
                                    제공에 따른 서비스 제공, 데이터 전달,
                                    이용내역 관리, 요금 정산을 목적으로
                                    개인정보를 처리합니다.
                                </p>
                            </li>
                        </div>
                        <div className={styles.subSection}>
                            <li>
                                (3) 부가서비스의 제공
                                <p>
                                    신규 서비스(제품) 개발 및 맞춤 서비스 제공,
                                    서비스의 유효성 확인, 접속빈도 파악 또는
                                    회원의 서비스 이용에 대한 통계, 정보제공 및
                                    부가서비스 제공을 위한 목적으로 개인정보를
                                    처리합니다.
                                </p>
                            </li>
                        </div>
                    </ul>
                    <p>나. 비회원</p>
                    <ul>
                        <li>
                            (1) 서비스 제공
                            <p>
                                서비스 제공에 관한 계약 이행 및 서비스 제공에
                                따른 데이터 제공 및 내역서 등의 목적으로
                                개인정보를 처리합니다.
                            </p>
                        </li>
                        <div className={styles.subSection}>
                            <li>
                                (2) 부가서비스의 제공
                                <p>
                                    신규 서비스(제품) 개발 및 맞춤 서비스 제공,
                                    서비스의 유효성 확인, 접속빈도 파악 또는
                                    서비스 이용에 대한 통계, 정보제공 및
                                    부가서비스 제공을 위한 목적으로 개인정보를
                                    처리합니다.
                                </p>
                            </li>
                        </div>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>3. 개인정보의 처리 및 보유 기간</h2>
                    <p>
                        <strong>
                            <u>
                                회사는 원칙적으로 개인정보 수집 및 이용목적이
                                달성된 후에는 해당 정보를 지체 없이 파기합니다.
                                단, 부정 이용 방지를 위하여 회원 탈퇴 후 1년
                                동안 해당 회원의 이메일 주소, 탈퇴 일자 정보,
                                성명 등을보유하며 관계법령의 규정에 의하여
                                보존할 필요가 있는 경우 회사는 해당 기간 동안
                                회원정보를 보관합니다. 비회원의 경우 부정 거래
                                등의 방지를 위해 최종 서비스 사용 후 1년 동안
                                해당 이용자의 성명, 이메일 주소 및 최종 서비스
                                사용 일자 등을 보유합니다.
                            </u>
                        </strong>
                    </p>
                    <p>
                        * 귀하는 개인정보 수집 동의를 거부할 권리가 있으며, 거부
                        시 회사가 제공하는 서비스를 이용할 수 없습니다.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2 className={styles.subSectionTitle}>
                        <strong>[필수] 개인정보 수집∙이용 안내 및 동의</strong>
                    </h2>
                    <p>
                        회사는 서비스 제공을 위하여 본 개인정보 수집∙이용 내용을
                        사전에 안내하고 있습니다.
                    </p>
                    <p>
                        이용자가 본 안내문을 확인한 후 서비스를 계속 이용하거나,
                        “계속”, “로그인”, “인증번호 받기”, “서비스 이용” 등의
                        절차를 진행하는 경우, 이용자는 본 개인정보 수집∙이용
                        내용에 이견이 없으며 이에 동의한 것으로 봅니다.
                    </p>
                    <p>
                        이용자는 개인정보 수집∙이용에 동의하지 않을 권리가
                        있으며, 동의하지 않는 경우 서비스 이용이 제한될 수
                        있습니다.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2 className={styles.centeredTitle}>개인정보 처리방침</h2>
                    <p>
                        주식회사 한국증권대차(이하 ‘회사’)는 「개인정보
                        보호법」등 관련 법규에 따라 고객의 개인정보 및 권익을
                        보호하고 개인정보와 관련한 고객의 고충을 원활하게 처리할
                        수 있도록 다음과 같은 처리방침을 두고 있습니다. 회사가
                        개인정보처리방침을 개정하는 경우 회사가 운영하는
                        웹사이트 또는 어플리케이션(이하 ‘사이트’)을 통하여
                        공지하거나 개별적으로 공지합니다.
                    </p>
                    <p>이 방침은 2026년 6월 15일부터 시행됩니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>1. 수집하는 개인정보 항목</h2>
                    <p>
                        회사는 고객에 대한 서비스의 제공, 원활한 고객상담 등을
                        위하여 회원(서비스를 제공 받기 위하여 회사와 이용계약을
                        체결하거나 이용자 아이디를 부여 받은 고객) 및
                        비회원(회원이 아닌 고객)으로부터 다음과 같은 정보를
                        수집합니다.
                    </p>
                    <p>가. 회원</p>
                    <ul>
                        <li>
                            (1) 필수 수집 항목: 성명, 비밀번호, 이메일, 회사명,
                            회사 전화번호
                        </li>
                        <li>
                            (2)서비스 이용과정이나 사업 처리과정에서 아래와 같은
                            정보들이 생성되어 수집될 수 있습니다: 서비스 이용
                            기록, 접속 로그, 접속 IP정보, 쿠키
                        </li>
                    </ul>
                    <p>나. 비회원</p>
                    <ul>
                        <li> (1) 필수 수집 항목: 성명, 이메일, 회사명</li>
                        <li>
                            {" "}
                            (2) 서비스 이용과정이나 사업 처리과정에서 아래와
                            같은 정보들이 생성되어 수집될 수 있습니다: 서비스
                            이용 기록, 접속 로그, 접속 IP정보, 디바이스 ID, 쿠키
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>2. 개인정보의 수집 방법</h2>
                    <p>가. 사이트를 통한 회원 가입, 설문조사</p>
                    <p>나. 사이트를 통한 고객의 정보 입력</p>
                    <p>다. 생성정보 수집 툴을 통한 수집</p>
                </div>
                <div className={styles.section}>
                    <h2>3. 개인정보의 수집 목적</h2>
                    <p>회사는 다음과 같은 목적으로 개인정보를 수집합니다.</p>
                    <p>가. 회원</p>
                    <ul>
                        <li>
                            (1) 회원가입 및 관리
                            <p>
                                회원 가입의사 확인, 회원제 서비스 제공에 따른
                                본인확인, 본인 식별·인증, 회원자격 유지·관리,
                                서비스 부정이용 방지, 각종 고지·통지, 서비스
                                관련 문의 및 불만사항 처리, 분쟁 조정을 위한
                                기록 보존, 새로운 서비스의 소개 및 고지사항
                                전달, 본인 의사 확인을 목적으로 개인정보를
                                처리합니다.
                            </p>
                        </li>
                        <li>
                            (2) 서비스 제공
                            <p>
                                서비스 제공에 관한 계약 이행 및 서비스 제공에
                                따른 서비스 제공, 데이터 전달, 이용내역 관리,
                                청구서 발송 및 요금 정산을 목적으로 개인정보를
                                처리합니다.
                            </p>
                        </li>
                        <li>
                            (3) 부가서비스의 제공
                            <p>
                                신규 서비스(제품) 개발 및 맞춤 서비스 제공,
                                서비스의 유효성 확인, 접속빈도 파악 또는 서비스
                                이용에 대한 통계, 정보제공 및 부가서비스 제공을
                                위한 목적으로 개인정보를 처리합니다.
                            </p>
                        </li>
                    </ul>
                    <p>나. 비회원</p>
                    <ul>
                        <li>
                            (1) 서비스 제공
                            <p>
                                서비스 제공에 관한 계약 이행 및 서비스 제공에
                                따른 데이터 제공 및 내역서 등의 목적으로
                                개인정보를 처리합니다.
                            </p>
                        </li>
                        <li>
                            (2) 부가서비스의 제공
                            <p>
                                신규 서비스(제품) 개발 및 맞춤 서비스 제공,
                                서비스의 유효성 확인, 접속빈도 파악 또는 서비스
                                이용에 대한 통계, 정보제공 및 부가서비스 제공을
                                위한 목적으로 개인정보를 처리합니다.
                            </p>
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>4.개인정보의 처리 및 보유 기간</h2>
                    <p>
                        회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된
                        후에는 해당 정보를 지체 없이 파기합니다. 단, 내부 방침에
                        의해 고객에게 개인정보 보관 기간에 대해 별도의 동의를
                        얻은 경우 또는 아래의 경우 회사는 해당 기간 동안
                        고객정보를 보관합니다.
                    </p>
                    <p>가. 부정 이용 방지를 위한 보유</p>
                    <p>
                        반복적인 회원 탈퇴 및 재가입으로 지장을 초래하거나
                        그밖에 경제적 이익 취득 등 불법, 편법 행위 차단을 위해
                        회원 탈퇴 후 1년 동안 해당 회원의 이메일 주소, 탈퇴 일자
                        등을 보유합니다. 비회원의 경우 부정 거래 등의 방지를
                        위해 최종 서비스 사용 후 1년 동안 해당 이용자의 성명,
                        이메일 주소 및 최종 서비스 사용 일자 등을 보유합니다.
                    </p>
                    <p>나. 관련 법령에 의한 보유</p>
                    <p>
                        상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관련
                        법령의 규정에 의하여 일정 기간 정보를 보유해야 할 필요가
                        있을 경우 법령이 지정한 기간 동안 보유합니다.
                    </p>
                    <ul>
                        <li>
                            (1) 계약 또는 청약철회 등에 관한 기록 보유: 5년
                            (전자상거래 등에서의 소비자보호에 관한 법률)
                        </li>
                        <li>
                            (2) 대금결제 및 재화 등의 공급에 관한 기록 보유: 5년
                            (전자상거래 등에서의 소비자보호에 관한 법률)
                        </li>
                        <li>
                            (3) 소비자 불만 또는 분쟁 처리에 관한 기록 보유: 3년
                            (전자상거래 등에서의 소비자보호에 관한 법률)
                        </li>
                        <li>
                            (4) 방문에 관한 기록 보유: 3개월 (통신비밀보호법)
                        </li>
                        <li>
                            (5) 서비스 이용 관련 기록: 관련 법령상 보존 의무가
                            있는 경우 해당 기간
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>5. 개인정보의 파기절차 및 방법</h2>
                    <p>
                        회사는 원칙적으로 개인정보 보유기간이 종료되거나
                        개인정보 처리목적이 달성된 경우에는 지체없이 해당
                        개인정보를 파기합니다. 파기의 절차, 기한 및 방법은
                        다음과 같습니다.
                    </p>
                    <ul>
                        <li>
                            1. 파기절차 및 기한
                            <p>
                                고객이 입력한 정보는 목적 달성 후 내부 방침 및
                                기타 관련 법령에 따라 즉시 혹은 일정기간 저장 후
                                파기됩니다. 이 때, 보관하는 개인정보는 법률에
                                의한 경우 이외의 다른 목적으로 이용되지
                                않습니다.
                            </p>
                        </li>
                        <li>
                            2. 파기방법
                            <p>
                                종이에 출력된 개인정보는 분쇄기로 분쇄하거나
                                소각하여 파기합니다. 전자적 파일 형태로 저장된
                                개인정보는 기록을 재생할 수 없도록 하는 기술적
                                방법으로 삭제합니다.
                            </p>
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>6. 개인정보의 제3자 제공</h2>
                    <ul>
                        <li>
                            1. 회사는 고객의 개인정보를 사전에 고지한 범위
                            내에서만 사용하며, 고객의 사전 동의 없이는 그 범위를
                            벗어나 이용하거나 원칙적으로 고객의 개인정보를
                            외부에 공개하지 않습니다. 다만, 아래의 경우에는
                            예외로 합니다:
                            <ul>
                                <li>
                                    (1) 법령의 규정에 의거하거나, 수사 목적으로
                                    법령에 정해진 절차와 방법에 따라 요구된 경우
                                </li>
                                <li>
                                    (2) 통계작성, 학술연구, 시장조사를 위하여
                                    특정 개인을 식별할 수 없는 형태로 제휴 또는
                                    협력업체에 제공하는 경우
                                </li>
                                <li>
                                    (3) 고객이 별도의 회사와 개별계약을 체결하여
                                    제3자 제공을 요청한 경우
                                </li>
                            </ul>
                        </li>
                        <li>
                            나. 회사가 제 3자에게 제공하고자 하는 정보는 회사가
                            고객으로부터 개인정보 수집ㆍ이용 동의를 받고
                            취득하는 모든 정보가 해당됩니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>7. 개인정보처리의 위탁</h2>
                    <ol>
                        <li>
                            가. 회사는 위탁계약 체결 시 「개인정보 보호법」
                            제26조에 따라 위탁업무 수행목적 외 개인정보
                            처리금지, 기술적ㆍ관리적 보호조치, 재위탁 제한,
                            수탁자에 대한 관리ㆍ감독, 책임에 관한 사항을 계약서
                            등 문서에 명시하고, 수탁자가 개인정보를 안전하게
                            처리하는지를 감독하게 됩니다. 나. 위탁업무의
                            내용이나 수탁자가 변경될 경우에는 본 개인정보
                            처리방침을 통하여 공개합니다.
                        </li>
                    </ol>
                </div>
                <div className={styles.section}>
                    <h2>8. 이용자 및 법정대리인의 권리·의무 및 그 행사방법 </h2>
                    <p>
                        이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수
                        있습니다.
                    </p>
                    <ol>
                        <li>
                            가. 고객 및 법정대리인은 언제든지 등록되어 있는
                            본인의 개인정보를 열람, 수정할 수 있습니다. 고객은
                            개인정보의 열람, 수정을 위하여 서비스에 등록된
                            정보를 클릭하거나 설정 메뉴에 접근하여 계정 정보 등
                            등록된 개인정보를 직접 열람하거나 수정할 수
                            있습니다.
                        </li>
                        <li>
                            나. 위 가.항에 의한 열람 및 수정은 개인정보
                            관리담당자에게 서면, 전화, 또는 이메일을 통하여
                            요청할 수도 있습니다.
                        </li>
                        <li>
                            다. 회원탈퇴를 원하는 경우 개인정보 관리담당자에게
                            서면 또는 이메일로 요청할 수 있습니다.
                        </li>
                        <li>
                            고객이 개인정보의 오류에 대한 정정을 요청한 경우,
                            정정 완료 전까지 당해 개인정보를 이용 또는 제공하지
                            않습니다. 또한, 잘못된 개인정보를 제3자에게 이미
                            제공한 경우에 회사는 정정 처리결과를 제3자에게
                            지체없이 통지합니다.
                        </li>
                        <li>
                            다른 법령에서 당해 개인정보가 수집 대상으로 되어
                            있는 경우에는 그 삭제를 요구할 수 없습니다.
                        </li>
                    </ol>
                </div>
                <div className={styles.section}>
                    <h2>
                        9. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한
                        사항{" "}
                    </h2>
                    <p>
                        가. 회사는 개별적인 맞춤서비스를 제공하기 위해
                        이용정보를 저장하고 수시로 불러오는 ‘쿠기(cookie)’를
                        사용합니다.
                    </p>
                    <p>
                        나. 쿠키는 웹사이트를 운영하는데 이용되는 서버가
                        이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며
                        이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도
                        합니다.{" "}
                    </p>
                    <ol>
                        <li>
                            쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹
                            사이트들에 대한 방문 및 이용형태, 인기 검색어,
                            보안접속 여부 등을 파악하여 이용자에게 최적화된 정보
                            제공을 위해 사용됩니다.
                        </li>
                        <li>
                            쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구
                            {">"}인터넷 옵션{">"}개인정보 메뉴의 옵션 설정을
                            통해 쿠키 저장을 거부할 수 있습니다.
                        </li>
                        <li>
                            쿠키 저장을 거부할 경우 맞춤형 서비스 이용에
                            어려움이 발생할 수 있습니다.
                        </li>
                    </ol>
                </div>
                <div className={styles.section}>
                    <h2>10. 개인정보의 안전성 확보 조치 </h2>
                    <p>
                        회사는 고객의 개인정보를 안전하게 관리하기 위하여 최선을
                        다하며 개인정보보호법에서 요구하는 사항을 철저히
                        준수하고 있습니다. 회사의 과실로 개인정보의 상실, 유출,
                        변조, 훼손이 유발된 경우 회사는 즉각 고객에게 사실을
                        알리고 적절한 대책을 강구할 것입니다. 개인정보보호를
                        위한 기술 및 관리 내용은 아래와 같습니다.
                    </p>
                    <p>
                        가. 관리적 조치: 내부관리계획 수립·시행, 전담조직 운영,
                        정기적 직원 교육
                    </p>
                    <p>
                        나. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리,
                        접근통제시스템 설치, 개인정보의 암호화, 보안프로그램
                        설치 및 갱신
                    </p>
                    <p>다. 물리적 조치: 전산실, 자료보관실 등의 접근통제</p>
                </div>
                <div className={styles.section}>
                    <h2>11. 개인정보 처리방침 변경 </h2>
                    <p>
                        이 개인정보처리방침은 시행일부터 적용되며, 법령 및
                        방침에 따른 변경내용의 추가, 삭제 및 정정은 변경 시행
                        7일 전까지 공지사항을 통하여 고지합니다.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>12. 고객의 권리와 의무</h2>
                    <p>
                        고객은 개인정보를 최신의 상태로 정확하게 입력하여 불의의
                        사고를 예방해 주시기 바랍니다. 부정확한 정보의 입력으로
                        인해 발생하는 사고의 책임은 고객에게 있으며, 타인 정보의
                        도용 등 허위정보를 입력할 경우 서비스 이용 자격이 상실될
                        수 있습니다. 회사는 타인의 이메일 주소 또는 기타
                        개인정보를 도용한 회원가입 또는 서비스 이용이 발견되는
                        경우, 지체 없이 해당 아이디에 대한 서비스 이용 정지 또는
                        회원 탈퇴 등 필요한 조치를 취합니다.
                    </p>
                    <p>
                        회사는 고객 개인의 실수나 인터넷 이용에 수반되는 위험과
                        관련하여서는 책임을 지지 않습니다. 고객은 본인의
                        개인정보를 보호하기 위해 자신의 ID, 비밀번호 및 OTP 등록
                        코드를 적절하게 관리하여야 할 의무가 있으며, 다른 사람이
                        추측할 수 있는 쉬운 비밀번호의 사용은 피하여 주시고,
                        정기적으로 비밀번호를 변경하는 것이 바람직합니다.{" "}
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>13. 개인정보 보호책임자 지정</h2>
                    <p>
                        회사는 고객의 개인정보 관련 문의사항 및 불만 처리를
                        위하여 아래와 같이 개인정보 보호책임자 및 관리담당자를
                        지정하고 있습니다.
                    </p>
                    <ul>
                        <li>▶ 개인정보 보호책임자 </li>
                        <li>성명 : 하재우</li>
                        <li>직위: 이사</li>
                        <li>
                            이메일:{" "}
                            <a href="mailto:support@kslnetwork.com">
                                support@kslnetwork.com
                            </a>
                        </li>
                        <li>▶ 개인정보 관리담당자</li>
                        <li>성명 : 하재우</li>
                        <li>직위: 이사</li>
                        <li>
                            이메일:{" "}
                            <a href="mailto:support@kslnetwork.com">
                                support@kslnetwork.com
                            </a>
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>14. 정보주체의 권익침해에 대한 구제방법</h2>
                    <p>
                        회사의 자체적인 개인정보 처리나 피해구제 결과에 만족하지
                        못하거나 보다 자세한 도움이 필요한 경우에는 아래 국가
                        기관에 문의하여 주시기 바랍니다.
                    </p>
                    <ul>
                        <li>
                            ▶ 개인정보 침해신고센터: 118 (privacy.kisa.or.kr){" "}
                        </li>
                        <li>
                            ▶ 개인정보 분쟁조정위원회: 1833-6972 (
                            <a href="www.kopico.go.kr">www.kopico.go.kr</a>)
                        </li>
                        <li>▶ 대검찰청 : 1301 (www.spo.go.kr)</li>
                        <li>
                            ▶ 경찰청 사이버안전국 : 182 (
                            <a href="http://cyberbureau.police.go.kr">
                                http://cyberbureau.police.go.kr
                            </a>
                            )
                        </li>
                    </ul>
                </div>
            </div>
            <div className={styles.document}>
                <h1>Privacy Policy</h1>
                <div className={`${styles.section} ${styles.intro}`}>
                    <ul>
                        <li>
                            This policy sets out:
                            <ul>
                                <li>
                                    (1) the information we collect about you
                                    when you visit our website (https://[Your
                                    CPTY ID].truweb.io and guest portals), use
                                    our products or services, or otherwise
                                    interact with us through including but not
                                    limited to API (Application Programming
                                    Interface), file delivery, or messaging
                                    queue;
                                </li>
                                <li>
                                    (2) how we use, share, store, and secure the
                                    information; and
                                </li>
                                <li>
                                    (3) how you may access and control the
                                    information.
                                </li>
                            </ul>
                        </li>
                        <li>
                            In this policy, “<b>“KSL”</b>,” “<b>“Tru”</b>,” “
                            <b>us</b>,” “<b>we</b>,” or “<b>our</b>” refers to
                            Korea Securities Lending Co., Ltd. and “Platform”
                            means any channel, including our website, through
                            which you may access our products or services.
                        </li>
                        <li>
                            In this policy, “<b>personal information</b>” refers
                            to any data, information, or combination of data and
                            information that is provided by you to us, or
                            through your use of our products or services, that
                            relates to an identifiable individual.
                        </li>
                        <li>
                            It is important that you read this privacy policy
                            together with any other privacy policy or fair
                            processing policy we may provide on specific
                            occasions when we are collecting or processing
                            personal data about you so that you are fully aware
                            of how and why we are using your data. This privacy
                            policy supplements other notices and privacy
                            policies and is not intended to override them.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>1. What information we collect about you</h2>
                    <ul>
                        <li>
                            1.1 We collect the following types of information
                            about you:
                            <ul>
                                <li>
                                    (a) account and profile information that you
                                    provide when you register for an account or
                                    sign up for our products or services, for
                                    example your name, title, physical address,
                                    email address, phone number, login
                                    information, or company affiliation
                                    (collectively, “<b>Account Data</b>”);
                                </li>
                                <li>
                                    (b) information you provide through support
                                    channels, for example when you report a
                                    problem to us or interact with our support
                                    team, including any contact information,
                                    documentation, or screenshots (collectively,
                                    “<b>Support Data</b>”);
                                </li>
                                <li>
                                    (c) communication, and other preferences
                                    that you set when you set up your account or
                                    profile, or when you participate in a survey
                                    or a questionnaire that we send you
                                    (collectively, “<b>Preference Data</b>”);
                                </li>
                                <li>
                                    (d) information about your device or
                                    connection and information we collect
                                    through cookies and other data collection
                                    technologies (please read our Cookies Policy
                                    for details) (collectively, “
                                    <b>Technical Data</b>”); and
                                </li>
                                <li>
                                    (e) Information about your use of or visit
                                    to our Platform (collectively, “
                                    <b>Usage Data</b>
                                    ”).
                                </li>
                            </ul>
                        </li>
                        <li>
                            1.2 We collect the above information when you
                            provide it to us or when you use or visit our
                            Platform.
                        </li>
                        <li>
                            1.3 We do not collect sensitive data or special
                            category data about you. This includes details about
                            your race, ethnic origin, politics, religion, trade
                            union membership, genetics, biometrics, health, or
                            sexual orientation.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>2. How we use information we collect</h2>
                    <ul>
                        <li>
                            2.1 We only use your personal information where the
                            law allows us to. We use your personal information
                            only where:
                            <ul>
                                <li>
                                    (a) we need to perform the contract we have
                                    entered into (or are about to enter into)
                                    with you, including to operate our products
                                    or services, to provide customer support and
                                    personalised features, and to protect the
                                    safety and security of our Platform in which
                                    case you are obliged, for the performance of
                                    the contract, to provide those personal
                                    information without which we may not be able
                                    to operate our products or services;
                                </li>
                                <li>
                                    (b) it satisfies a legitimate interest which
                                    is not overridden by your fundamental rights
                                    or data protection interests, for example
                                    for research and development, and in order
                                    to protect our legal rights and interests
                                </li>
                                <li>
                                    (c) you have given us consent to do so for a
                                    specific purpose, for example we may send
                                    you service-related information or publish
                                    your information as part of our testimonials
                                    or customer stories to promote our products
                                    or services with your permission; or
                                </li>
                                <li>
                                    (d) we need to comply with a legal or
                                    regulatory obligation.
                                </li>
                            </ul>
                        </li>
                        <li>
                            2.2 If you have given us consent to use your
                            personal information for a specific purpose, you
                            have the right to withdraw your consent any time by
                            contacting us (please refer to paragraph 7 for
                            contact information), but please note this will not
                            affect any use of your information that has already
                            taken place.
                        </li>
                        <li>
                            2.3 We do not share your personal information with
                            any company outside our group for
                            non-service-related purposes, unless with your
                            explicit, specific consent to do so.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>3. How we share information we collect</h2>
                    <ul>
                        <li>
                            3.1 We may share personal information on aggregated
                            or de-identified basis with third parties for
                            research and analysis, profiling, and similar
                            purposes to help us improve our products and
                            services.
                        </li>
                        <li>
                            3.2 If you use any third-party software in
                            connection with our products or services, for
                            example any third-party software that our Platform
                            integrates with, you might give the third-party
                            software provider access to your account and
                            information. Policies and procedures of third-party
                            software providers are not controlled by us, and
                            this policy does not cover how your information is
                            collected or used by third-party software providers.
                            We encourage you to review the privacy policies of
                            third-party software providers before you use the
                            third-party software.
                        </li>
                        <li>
                            3.3 Our Platform may contain links to third-party
                            websites over which we have no control. If you
                            follow a link to any of these websites or submit
                            information to them, your information will be
                            governed by their policies. We encourage you to
                            review the privacy policies of third-party websites
                            before you submit information to them.
                        </li>
                        <li>
                            3.4 We may share your information with government
                            and law enforcement officials to comply with
                            applicable laws or regulations, for example when we
                            respond to claims, legal processes, law enforcement,
                            or national security requests.
                        </li>
                        <li>
                            3.5 If we are acquired by a third party as a result
                            of a merger, acquisition, or business transfer, your
                            personal information may be disclosed and/or
                            transferred to a third party in connection with such
                            transaction. We will notify you if such transaction
                            takes place and inform you of any choices you may
                            have regarding your information.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>4. How we store and secure information we collect</h2>
                    <ul>
                        <li>
                            4.1 We use data hosting service providers to host
                            the information we collect.
                        </li>
                        <li>
                            4.2 We have adopted the following measures to
                            protect the security and integrity of your personal
                            information:
                            <ul>
                                <li>
                                    (a) access to your personal information is
                                    restricted to personnel or service providers
                                    on a strictly need-to-know basis, who will
                                    only process your information on our
                                    instructions and who are subject to a duty
                                    of confidentiality; and
                                </li>
                                <li>
                                    (b) our information collection, storage, and
                                    processing practices are reviewed regularly.
                                </li>
                            </ul>
                        </li>
                        <li>
                            4.3 We have put in place procedures to deal with any
                            suspected privacy breach and will notify you and any
                            applicable regulator of a breach where we are
                            legally required to do so.
                        </li>
                        <li>
                            4.4 While we implement safeguards designed to
                            protect your information, please note that no
                            transmission of information on the Internet is
                            completely secure. We cannot guarantee that your
                            information, during transmission through the
                            Internet or while stored on our systems or processed
                            by us, is absolutely safe and secure.
                        </li>
                        <li>
                            4.5 We only retain personal information for so long
                            as it is reasonably necessary to fulfill the
                            purposes we collected it for, including for the
                            purposes of satisfying any legal, accounting, or
                            reporting requirements. We periodically review the
                            basis and appropriateness of our data retention
                            policy.
                        </li>
                        <li>
                            4.6 Destruction of Personal Information
                            <ul>
                                <li>
                                    (a) Where it becomes unnecessary to retain
                                    personal information such as the expiry of
                                    the retention period and fulfillment of the
                                    purpose of processing of personal
                                    information, we shall immediately destroy
                                    your personal information.
                                </li>
                                <li>
                                    (b) Notwithstanding paragraph (a) above, if
                                    we are obligated to continue to retain your
                                    personal information to comply with
                                    applicable laws/regulations, we shall
                                    transfer the personal information to a
                                    separate database or storage place for
                                    storage.
                                </li>
                                <li>
                                    (c) The process and method of destruction of
                                    personal information shall be as follows:
                                    <ul>
                                        <li>
                                            (i) Process of Destruction <br />
                                            We shall identify the personal
                                            information to be destroyed and
                                            destroy such personal information
                                            with your approval.
                                        </li>
                                        <li>
                                            (ii) Method of Destruction <br />
                                            We shall destroy the personal
                                            information (x) by taking measures
                                            to procure that it cannot be
                                            reproduced electronically if such
                                            personal information is
                                            recorded/stored electronically; or
                                            (y) by pulverizing or incinerating
                                            it if it is recorded/stored on a
                                            physical document.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>5. Your rights</h2>
                    <ul>
                        <li>
                            5.1 You have the right to:
                            <ul>
                                <li>
                                    (a) be informed of what we do with your
                                    personal information;
                                </li>
                                <li>
                                    (b) request a copy of personal information
                                    we hold about you;
                                </li>
                                <li>
                                    (c) require us to correct any inaccuracy or
                                    error in any personal information we hold
                                    about you;
                                </li>
                                <li>
                                    (d) request erasure of your personal
                                    information (note, however, that we may not
                                    always be able to comply with your request
                                    of erasure for record keeping purposes, to
                                    complete transactions, or to comply with our
                                    legal obligations);
                                </li>
                                <li>
                                    (e) object to or restrict the processing by
                                    us of your personal information;
                                </li>
                                <li>
                                    (f) request to receive some of your personal
                                    information in a structured, commonly used,
                                    and machine readable format, and request
                                    that we transfer such information to another
                                    party; and
                                </li>
                                <li>
                                    (g) withdraw your consent at any time where
                                    we are relying on consent to process your
                                    personal information (although this will not
                                    affect the lawfulness of any processing
                                    carried out before you withdraw your
                                    consent).
                                </li>
                            </ul>
                        </li>
                        <li>
                            5.2 As a security measure, we may need specific
                            information from you to help us confirm your
                            identity when processing your privacy requests or
                            when you exercise your rights.
                        </li>
                        <li>
                            5.3 Any request under paragraph 5.1 will normally be
                            addressed free of charge. However, we may charge a
                            reasonable administration fee if your request is
                            clearly unfounded, repetitive, or excessive.
                        </li>
                        <li>
                            5.4 We will respond to all legitimate requests
                            within 10 business days. Occasionally, it may take
                            us up to two (2) additional months if your request
                            is particularly complex or if you have made a number
                            of requests.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>6. Changes to this policy</h2>
                    <ul>
                        <li>
                            6.1 We may amend this policy from time to time by
                            posting the updated policy on our Platform. By
                            continuing to use our Platform after the changes
                            come into effect, you agree to be bound by the
                            revised policy.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>7. Contact us</h2>
                    <ul>
                        <li>
                            7.1 If you have any questions about this privacy
                            policy or our privacy practices, please contact our
                            Data Controller and Data Protection Officer using
                            the details set out below.
                            <br />
                            Data Protection Officer: Jae Woo Ha
                            <br />
                            Data Controller: Jae Woo Ha
                            <br />
                            Email address:{" "}
                            <a href="mailto:support@kslnetwork.com">
                                support@kslnetwork.com
                            </a>
                        </li>
                        <li>
                            7.2 Please contact us in the first instance if you
                            have any questions or concerns. If you have
                            unresolved concerns, you have the right to file a
                            complaint with a data protection authority in the
                            country where you live or work or where you feel
                            your rights have been infringed.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <p>
                        Effective: 15<sup>th</sup> of June 2026
                    </p>
                </div>
            </div>

            <div className={styles.document} id="cookiePolicy">
                <h1>COOKIES POLICY</h1>
                <div className={styles.section}>
                    When visiting Our Platform, our servers may query your
                    computer to see if there are cookies previously set by KSL.
                    A cookie is a text file that is created when your browser
                    visits a particular website, such as an KSL website.
                    Afterwards, every time you visit the KSL website, your
                    browser retrieves and sends this file to the KSL website's
                    server. Cookies enhance the website user experience by:
                    <ul className={styles.bullet}>
                        <li>
                            Helping KSL authenticate you as a user when you log
                            in to a secure area of the website;
                        </li>
                        <li>
                            Storing information about your website user
                            activities so you may easily pick up where you left
                            off on the KSL server's pages;
                        </li>
                        <li>
                            Storing your user preferences, which allows you to
                            customize how information is presented through site
                            layouts or themes; and
                        </li>
                        <li>
                            Personalizing the manner in which KSL responds to
                            you via service-related communications.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    The cookies KSL collects may include the following
                    information: a unique identifier, user preferences, and
                    profile information used to personalize the content shown to
                    the individual users. It is your choice whether you allow
                    KSL to store such information on your computer or device.
                    You may be able to set your web browser to alert you when a
                    cookie is being used, and may use your browser to accept or
                    reject the cookie; additionally, you may also disable the
                    cookie feature on your browser entirely. However, disabling
                    cookies may prevent you from using some features on KSL
                    websites. You can find more detailed information about
                    cookies and how they work at{" "}
                    <a
                        href="https://aboutcookies.org"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        AboutCookies.org
                    </a>
                    .
                </div>
                <div className={styles.section}>
                    You can set your browser to refuse all or some browser
                    cookies, or to alert you when websites set or access
                    cookies. If you disable or refuse cookies, please note that
                    some parts of this website may become inaccessible or not
                    function properly.
                </div>
            </div>
        </div>
    );
};
